import React from 'react';
import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@atlassian/jira-global-settings-layout/src/index.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarGlobalSettingsProducts from '@atlassian/jira-navigation-apps-sidebar-global-settings-products/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { jsmGlobalCustomerAccessAffectedProjectsResource } from '@atlassian/jira-router-resources-admin-pages-jsm-customer-access/src/services/affected-projects/index.tsx';
import { jsmGlobalCustomerAccessSettingsResource } from '@atlassian/jira-router-resources-admin-pages-jsm-customer-access/src/services/settings/index.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { productsJsmCustomerAccessRoute } from '@atlassian/jira-router-routes-admin-pages-jsm-customer-access-routes/src/productsJsmCustomerAccessRoute.tsx';
import type CustomerAccessType from '@atlassian/jira-spa-apps-products-jsm-customer-access/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { Route } from '@atlassian/react-resource-router';

const LazyCustomerAccess = lazyForPaint<typeof CustomerAccessType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-products-customer-access", jiraSpaEntry: "async-admin-pages-customer-access" */ '@atlassian/jira-spa-apps-products-jsm-customer-access'
		),
	),
);

const ServiceDeskCustomerAccess = () => (
	<LazyPage
		Page={LazyCustomerAccess}
		pageId="spa-apps/admin-pages/customer-access"
		shouldShowSpinner={false}
	/>
);

export const productsJsmCustomerAccessRouteEntry: Route = createEntry(
	productsJsmCustomerAccessRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'admin.jsm-customer-access',
		component: ServiceDeskCustomerAccess,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SIDEBAR_ID.GLOBAL_PRODUCTS_SETTINGS,
			menuId: MENU_ID.SETTINGS,
			sidebar: AsyncSidebarGlobalSettingsProducts,
		},

		resources: [
			...getNavigationResources(),
			...getNavigationSidebarProductsSettingResource(),
			jsmGlobalCustomerAccessSettingsResource,
			jsmGlobalCustomerAccessAffectedProjectsResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyCustomerAccess],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-admin-pages-jsm-customer-access-entries/src/productsJsmCustomerAccessRouteEntry.tsx',
				whichExportToUse: 'productsJsmCustomerAccessRouteEntry',
			},

			enabled: true,
		},
	}),
);
